export default __webpack_public_path__ + "static/icon-26-2-7fb42747a27f9388ed9ef360b61ea80e.png";